import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-minimize-map-with-sidebar-button',
    templateUrl: './minimize-map-with-sidebar-button.component.html',
    styleUrls: ['./minimize-map-with-sidebar-button.component.scss'],
    standalone: false,
})
export class MinimizeMapWithSidebarButtonComponent {
}
